export default {
  SEARCH_SHORT: 'Zoeken..',
  SEARCH_LONG: 'Zoek een radiozender, show, podcast of muziekgenre',
  SEARCH_MOBILE: 'Zoeken binnen JUKE',
};
